export default function ProjsSAPStandardPages(){
  return(
    <div>
      Standard Pages coming soon! 
    </div>
  );
}